<template>
  <el-card>
    <el-form :inline="true" @submit.prevent>
      <el-form-item>
        <el-input v-model.trim="keyword" placeholder="会话ID/主题/内容" @keyup.enter="onSearch" />
      </el-form-item>
      <el-form-item>
        <el-select v-model="status" placeholder="全部状态" clearable style="width: 140px;">
          <el-option v-for="item in statusOptions" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" stripe border v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="user_id" label="用户ID" width="90" />
      <el-table-column prop="role_id" label="角色ID" width="90" />
      <el-table-column prop="session_id" label="会话ID" min-width="170" show-overflow-tooltip />
      <el-table-column label="状态" width="120">
        <template #default="{ row }">
          <el-tag :type="statusTagType(row.status)">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="topic" label="主题" min-width="140" show-overflow-tooltip />
      <el-table-column prop="reason" label="触发原因" min-width="180" show-overflow-tooltip />
      <el-table-column prop="message" label="消息" min-width="220" show-overflow-tooltip />
      <el-table-column label="计划时间" min-width="180">
        <template #default="{ row }">{{ fmt(row.follow_up_at) }}</template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page="query.page"
        :page-size="query.page_size"
        @current-change="onPageChange"
      />
    </div>
  </el-card>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { adminApi } from '../api/admin'

const keyword = ref('')
const status = ref('')
const list = ref([])
const total = ref(0)
const loading = ref(false)
const statusOptions = [
  { value: 'pending', label: '待发送' },
  { value: 'sent', label: '已发送' },
  { value: 'cancelled', label: '已取消' }
]
const query = ref({
  page: 1,
  page_size: 20
})

const fmt = (v) => (v ? new Date(v).toLocaleString() : '-')
const statusLabel = (v) => {
  const item = statusOptions.find((x) => x.value === v)
  return item ? item.label : (v || '-')
}
const statusTagType = (s) => {
  if (s === 'sent') return 'success'
  if (s === 'cancelled') return 'info'
  return 'warning'
}

async function load() {
  loading.value = true
  try {
    const data = await adminApi.followUps({
      keyword: keyword.value,
      status: status.value || '',
      page: query.value.page,
      page_size: query.value.page_size
    })
    list.value = data.list || []
    total.value = data.total || 0
  } catch (e) {
    ElMessage.error(e.message || '加载失败')
  } finally {
    loading.value = false
  }
}

function onSearch() {
  query.value.page = 1
  load()
}

function onReset() {
  keyword.value = ''
  status.value = ''
  query.value.page = 1
  load()
}

function onPageChange(page) {
  query.value.page = page
  load()
}

onMounted(load)
</script>
